import { numberToWords } from '../page';
import { roundUp } from '@/utils/format'; // ✅ Import roundUp

function PaymentAmount({ paymentAmount, setPaymentAmount, state, toast, maxAmount }) {
  // ✅ Round up balance due using roundUp function
  const balanceDue = Number(state?.balanceDue ?? 0);
  // When TDS is being deducted, the cash portion can only cover balanceDue minus
  // the TDS amount — maxAmount (passed by the parent) reflects that, else falls
  // back to the full balance due.
  const roundedBalanceDue = roundUp(
    maxAmount !== undefined ? maxAmount : balanceDue,
  ); // ✅ 0.12 → 1

  // ✅ Round up payment amount for display
  const displayPaymentAmount = paymentAmount
    ? roundUp(Number(paymentAmount))
    : '';

  const isOverBalance = Number(paymentAmount || 0) > roundedBalanceDue;
  const isBelowMinimum =
    Number(paymentAmount || 0) > 0 && Number(paymentAmount || 0) < 1;

  return (
    <div className="bg-white border border-[#e2e8f0] rounded-xl p-4">
      <p className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-3">
        Payment Amount
      </p>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 font-semibold">
          ₹
        </span>
        <input
          type="text"
          value={displayPaymentAmount || ''}
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d*\.?\d*$/.test(val)) {
              const nextAmount = Number(val || 0);
              if (nextAmount <= roundedBalanceDue) {
                setPaymentAmount(val);
              }
            }
          }}
          onBlur={() => {
            const num = Number(paymentAmount || 0);
            if (num > 0 && num < 1) {
              setPaymentAmount('1');
              toast?.warning('Minimum payment amount is ₹1');
            }
          }}
          className={`w-full h-11 pl-7 pr-3 text-lg font-bold border rounded-lg focus:outline-none ${
            isOverBalance || isBelowMinimum
              ? 'border-red-300 focus:border-red-500'
              : 'border-[#e2e8f0] focus:border-[#4f46e5]'
          }`}
          placeholder="Enter amount"
        />
      </div>
      <div className="flex items-center justify-between mt-1">
        <p className="text-xs text-slate-400">
          {maxAmount !== undefined && maxAmount !== roundUp(balanceDue)
            ? `Cash payable: ₹${roundedBalanceDue.toLocaleString('en-IN')} (of ₹${roundUp(balanceDue).toLocaleString('en-IN')} balance, net of TDS)`
            : `Balance due: ₹${roundedBalanceDue.toLocaleString('en-IN')}`}
        </p>
        {isOverBalance && (
          <p className="text-xs font-medium text-red-600">
            Cannot exceed balance due
          </p>
        )}
        {isBelowMinimum && (
          <p className="text-xs font-medium text-red-600">
            Minimum ₹1 required
          </p>
        )}
      </div>
      {paymentAmount > 0 && (
        <p className="text-xs text-slate-400 mt-1">
          {numberToWords(roundUp(Number(paymentAmount)))}
        </p>
      )}
    </div>
  );
}

export default PaymentAmount;
